import Http from '@/api/http';

export default class MailConfigXunDian extends Http {
  constructor() {
    super();
  }
  /**
   * 获取邮件提醒
   * @returns
   */
  mailConfigXunDian_getMailConfig() {
    return super.post('mailConfigXunDian/getMailConfig', ...arguments);
  }
  /**
   * 保存邮件设置
   * @returns
   */
  mailConfigXunDian_saveMailConfig() {
    return super.post('mailConfigXunDian/saveMailConfig', ...arguments);
  }
  /**
   * 选择用户列表
   * @returns
   */
  trialMessageUserConfigInner_userBriefSearchForP() {
    return super.post('trialMessageUserConfigInner/userBriefSearchForP', ...arguments);
  }
  /**
   * 查询选择的用户
   * @returns
   */
  trialMessageUserConfigInner_getList() {
    return super.post('trialMessageUserConfigInner/getList', ...arguments);
  }
  /**
   * 保存选择的用户
   * @returns
   */
  trialMessageUserConfigInner_save() {
    return super.post('trialMessageUserConfigInner/save', ...arguments);
  }

  // 到期提醒
  taskOverRemindInner_listByPage() {
    return super.post('taskOverRemindInner/listByPage', ...arguments);
  }
  // 处理提醒
  taskOverRemindInner_remindHandleMark() {
    return super.post('taskOverRemindInner/remindHandleMark', ...arguments);
  }
  taskOverRemindInner_findRemindUser() {
    return super.post('taskOverRemindInner/findRemindUser', ...arguments);
  }
  // 设置提醒用户
  taskOverRemindInner_setRemindUser() {
    return super.post('taskOverRemindInner/setRemindUser', ...arguments);
  }
  // 获取系统提示词
  aiPrompt_selectSystemPrompt() {
    return super.post('aiPrompt/selectSystemPrompt', ...arguments);
  }
  // 修改系统提示词
  aiPrompt_changePromptDetail() {
    return super.post('aiPrompt/changePromptDetail', ...arguments);
  }
}
